/**
 * ABC-Gruppen's own Trustpilot business unit (www.abcgruppen.se) — shared by
 * every ABC-SE surface that renders the DS TrustpilotWidget.
 */
export const ABC_TRUSTPILOT = {
  businessUnitId: '4bbfc2840000640005055234',
  locale: 'sv-SE',
  reviewUrl: 'https://se.trustpilot.com/review/www.abcgruppen.se',
};

export default ABC_TRUSTPILOT;
